import { useAppliedMapGroupId } from 'state/map';
import { useGroupIdQuery } from 'state/queryParams';

/**
 * Whether the map's current filter state can be trusted to match the
 * selected saved search, used to gate the map fetches (pins / list /
 * clusters).
 *
 * Selecting a saved search flips `groupIdQuery` synchronously, but the
 * search's real filters only load in asynchronously afterwards. In that gap
 * the filter state still holds the previous search's filters, so firing a
 * fetch would return the wrong results (the flicker) and produce a redundant
 * request once the real filters land. `appliedMapGroupId` is set only once a
 * group's filters have actually been applied (see useHandleProjectGroupSelect),
 * so fetches wait until it catches up to the selection. With no group
 * selected there is nothing to wait for.
 */
export const useAreGroupFiltersReady = (): boolean => {
  const { groupIdQuery } = useGroupIdQuery();
  const [appliedGroupId] = useAppliedMapGroupId();

  return !groupIdQuery || appliedGroupId === groupIdQuery;
};
